<!--账单详情表单-->
<template>
  <div class="main-content">
    <el-form class="bill-form-content" label-position="left" :label-width="isZh ? '85px' : '135px'" :model="billing">
      <el-row :gutter="5" type="flex">
        <el-col :span="8" style="width: 630px;">
          <div class="section" style="flex:1;height: 100%">
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_BillNo')">
                <el-input v-model="billing.billingNo" :disabled="true" no="1" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
                <el-input v-if="!isBySettlementAgent" v-model="billing.settlement" :disabled="true" no="2" />
                <cargo-advance-select
                  v-if="isBySettlementAgent"
                  filterable
                  no="settlement"
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(billing.accountId) === 0 ? '' : Number(billing.accountId)"
                  :disabled="isView"
                  :method-params="{'auto_accountId': true}"
                  :cache="false"
                  :tag-name="isZh ? 'chineseName' : 'englishName'"
                  :static-options="accountArray"
                  @parentCallBack="p=>{billing.accountId=p.value;$emit('accountIdChange')}"
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_SettlementAgent')">
                <el-input v-if="isBySettlementAgent" v-model="billing.settlementAgent" :disabled="true" no="settlementAgentId" />
                <cargo-advance-select
                  v-if="!isBySettlementAgent"
                  filterable
                  no="3"
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(billing.settlementAgentId) === 0 ? '' : Number(billing.settlementAgentId)"
                  :disabled="isView"
                  :method-params="{'auto_accountId': true}"
                  :cache="false"
                  :tag-name="isZh ? 'chineseName' : 'englishName'"
                  :static-options="settlementAgentArray"
                  @parentCallBack="p=>billing.settlementAgentId=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_InvoiceHeader')">
                <cargo-advance-select
                  :select-type="selectTypeNames.static_data_Title"
                  no="4"
                  :allow-create="!arSettlementUnitOptional || !billing.ar"
                  filterable
                  :cache="false"
                  :disabled="isView"
                  :default-value="invoiceTitleUuid"
                  tag-value="uuid"
                  :static-options="titleArray"
                  @parentCallBack="titleChangeEvent"
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('Partners.CustomerMailbox')">
                <el-input v-model="billing.customerEmail" :disabled="true" no="customerEmail" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_RegistrationAddress')">
                <el-input v-model="billing.buyerAddress" :disabled="isView" no="5" />
              </el-form-item>
            </el-col>
            <el-col class="inline">
              <el-form-item :label="$t('CargoMsg.Cargo_RegistrationNumber')">
                <el-input v-model="billing.buyerTaxAccount" :disabled="true" no="6" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                <el-input v-model="billing.buyerTelephone" :disabled="isView" no="7" />
              </el-form-item>
            </el-col>
            <el-col class="inline">
              <el-form-item :label="$t('CargoMsg.Cargo_DepositBank')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.static_data_TitleBank"
                  no="8"
                  :default-value="titleBankUuid"
                  :disabled="isView"
                  :cache="false"
                  tag-value="uuid"
                  :static-options="titleBankArray"
                  @parentCallBack="getBankCusFromChild"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')">
                <el-input v-model="billing.buyerBankAccount" :disabled="true" no="9" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_RevenueAndExpenditureType')">
                <el-input :disabled="true" no="10" :value="billing.ar ? $t('CargoMsg.Cargo_Receivable') : $t('CargoMsg.Cargo_Dues')" />
              </el-form-item>
            </el-col>
            <el-col class="inline">
              <el-form-item :label="$t('CargoMsg.Cargo_OwnerBankOfDeposit')">
                <cargo-advance-select
                  filterable
                  :cache="false"
                  :disabled="isView"
                  no="11"
                  :select-type="selectTypeNames.static_data_BankAccount"
                  :default-value="billing.bankAccountId === 0 ? '' : billing.bankAccountId"
                  :static-options="ourBankAccountArray"
                  @parentCallBack="getOurBankAccountFromChild"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')">
                <el-input v-model="billing.bankAccount" :disabled="true" no="12" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_BillDate')">
                <el-date-picker
                  v-model="billing.inputDate"
                  no="13"
                  type="date"
                  :clearable="false"
                  style="width: 100%"
                  :editable="false"
                  :disabled="isView"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="inputDateChange"
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_DueDate')">
                <el-date-picker
                  v-model="billing.dueDate"
                  no="14"
                  type="date"
                  :clearable="false"
                  style="width: 100%"
                  :editable="false"
                  :disabled="isView"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('CargoMsg.Cargo_AgentBillNo')">
                <el-input v-model="billing.counterPartyBillingNo" :disabled="(billing.state > 0 && !isView) || isView" no="15" />
              </el-form-item>
            </el-col>
            <el-col v-show="billing.billingType === BILLING_TYPE_INTERNAL.code && !billingNoteContainInvoice">
              <el-form-item :label="$t('Invoice.invoice_invoiceCategory')">
                <el-select v-model="billing.invoiceMakeType" :disabled="isView" no="17" :placeholder="isView ? '' : $t('CargoMsg.Cargo_PleaseSelect')" clearable @change="changeInvoiceMakeType">
                  <el-option v-for="(item,index) in invoiceMakeTypes" :key="index" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-show="billing.billingType === BILLING_TYPE_INTERNAL.code && !billingNoteContainInvoice">
              <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
                <el-select v-model="billing.invoiceType" :disabled="isView" no="16" :placeholder="isView ? '' : $t('CargoMsg.Cargo_PleaseSelect')" clearable>
                  <el-option v-for="(item,index) in invoiceTypes" :key="index" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-show="billing.billingType === BILLING_TYPE_INTERNAL.code || billing.billingType === BILLING_TYPE_OVERSEA.code">
              <el-form-item :label="$t('Billing.billingJob_settlementType')">
                <el-select v-model="billing.settlementType" :disabled="isView" no="18">
                  <el-option v-if="billing.settlementType === 0" :key="-1" label=" " :value="0" />
                  <el-option v-for="(item,index) in SETTLEMENT_TYPE_STATES" :key="index" :label="$store.getters.isZh ? item.chineseName : item.englishName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="billingFormParams.billingNoteContainInvoiceReques">
              <el-form-item :label="$t('CargoMsg.Cargo_InvoicingType')">
                <el-select v-model="billing.makeInvoiceType" :disabled="isView" no="makeInvoiceType" @change="makeInvoiceTypeChange">
                  <el-option :label="$t('CargoMsg.Cargo_LotteryDraw')" :value="0" />
                  <el-option :label="$t('CargoMsg.Cargo_SchoolMonth')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="billingNoteContainInvoice">
              <el-checkbox v-model="billing.detailMakeInvoice" :disabled="isView" @change="detailMakeInvoiceChange">{{ $t('CargoMsg.Cargo_DetailMakeInvoice') }}</el-checkbox>
              <el-checkbox v-model="billing.splitMakeInvoice" :disabled="isView">{{ $t('CargoMsg.Cargo_SplitMakeInvoice') }}</el-checkbox>
            </el-col>
            <el-col v-if="billingNoteContainInvoice && !billing.detailMakeInvoice">
              <cargo-ag-grid
                :grid-params.sync="invoiceGoodsName.gridParams"
                :grid-options="invoiceGoodsName.gridOptions"
                :column-defs="invoiceGoodsNameColumnDefs"
                :row-data="billing.billingBeforehandVOS"
                min-height="100px"
                style="width:100%;height:100px"
                @gridReady="params=>invoiceGoodsName.gridApi=params.api"
              />
            </el-col>
          </div>
        </el-col>
        <el-col :span="16" style="flex:1">
          <div class="section" style="flex:1;height: 100%">
            <div>
              <el-col :span="10" style="width: 550px;">
                <el-col>
                  <el-col :span="8">{{ $t('CargoMsg.Cargo_OriginalCurrency2') }}</el-col>
                  <el-col :span="8">{{ $t('CargoMsg.Cargo_Amount') }}</el-col>
                  <el-col :span="8">{{ $t('CargoMsg.Cargo_ExchangeRate2') }}</el-col>
                </el-col>
                <el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-input
                        v-model="billing.sourceCurrency1"
                        :disabled="true"
                        no="18"
                        style="width: 100px;"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-input-number
                        v-model="billing.amount1"
                        no="19"
                        controls-position="right"
                        :min="-999999999999"
                        :max="999999999999"
                        :precision="2"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <num-input
                        v-model="billing.sourceRate1"
                        no="20"
                        :min="0"
                        :max="999999999"
                        :precision="8"
                        :truncated-precision="sourceRate1Precision"
                        :disabled="billingFormParams.sourceRate1Enable"
                        @change="calculateAmount"
                      />
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-input
                        v-model="billing.sourceCurrency2"
                        no="21"
                        :disabled="true"
                        style="width: 100px;"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-input-number
                        v-model="billing.amount2"
                        no="22"
                        controls-position="right"
                        :min="-999999999999"
                        :max="999999999999"
                        :precision="2"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <num-input
                        v-model="billing.sourceRate2"
                        no="23"
                        :min="0"
                        :max="999999999"
                        :precision="8"
                        :truncated-precision="sourceRate2Precision"
                        :disabled="billingFormParams.sourceRate2Enable"
                        @change="calculateAmount"
                      />
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-input
                        v-model="billing.sourceCurrency3"
                        :disabled="true"
                        no="24"
                        style="width: 100px;"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-input-number
                        v-model="billing.amount3"
                        no="25"
                        controls-position="right"
                        :min="-999999999999"
                        :max="999999999999"
                        :precision="2"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <num-input
                        v-model="billing.sourceRate3"
                        no="26"
                        :min="0"
                        :max="999999999"
                        :precision="8"
                        :truncated-precision="sourceRate3Precision"
                        :disabled="billingFormParams.sourceRate3Enable"
                        @change="calculateAmount"
                      />
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="6">
                <el-col>
                  <el-form-item :label="$t('CargoMsg.Cargo_BillingCurrency')">
                    <cargo-advance-select
                      filterable
                      :select-type="selectTypeNames.basic_data_Currency"
                      no="27"
                      :default-value="billing.currency"
                      :disabled="isView"
                      :clearable="false"
                      @parentCallBack="currencyChangeEvent"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item :label="$t('Billing.billingForm_taxAmount')">
                    <el-input-number
                      v-model="billing.amount"
                      no="28"
                      controls-position="right"
                      :min="-999999999999"
                      :max="999999999999"
                      style="width:100%;"
                      :precision="2"
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item :label="$t('Billing.billingForm_taxFreeAmount')">
                    <el-input-number
                      v-model="billing.taxFreeAmount"
                      no="29"
                      controls-position="right"
                      :min="-999999999999"
                      :max="999999999999"
                      style="width:100%;"
                      :precision="2"
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
              </el-col>
              <el-col>
                <el-form-item label-width="0">
                  <span>{{ $t('CargoMsg.Cargo_Remarks') }}</span>
                  <el-input
                    v-model="billing.remark"
                    type="textarea"
                    no="30"
                    :rows="6"
                    :disabled="isView"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('CargoMsg.Cargo_AccountContacts')" label-width="105px;">
                    <cargo-advance-select
                      :select-type="selectTypeNames.static_data_Contact"
                      :allow-create="true"
                      no="31"
                      filterable
                      :cache="false"
                      clearable
                      :disabled="isView"
                      style="width: 200px;"
                      :default-value="billing.accountContacts"
                      :static-options="accountContactsArray"
                      @parentCallBack="accountContactChangeEvent"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('CargoMsg.Cargo_AccountContactsTel')">
                    <el-input v-model="billing.accountContactsTel" :disabled="isView" no="32" style="width: 100%;" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('CargoMsg.Cargo_AccountAddr')">
                    <el-input v-model="billing.accountAddr" :disabled="isView" no="33" style="width: 100%;" />
                  </el-form-item>
                </el-col>
              </el-col>
              <el-col>
                <el-form-item label-width="0">
                  <span>{{ $t('CargoMsg.Cargo_InvoicingRequirements') }}</span>
                  <el-input
                    v-model="billing.invoiceDemand"
                    type="textarea"
                    no="34"
                    :rows="6"
                    :disabled="isView"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="billingNoteContainInvoice">
                <div style="display: flex; width: 100%;padding-top: 10px">
                  <div style="width: 50%;padding-right: 5px">
                    <span>{{ $t('Invoice.invoice_invoiceRemarks') }}</span>
                    <el-input
                      v-model="billing.invoiceRemark"
                      type="textarea"
                      no="invoiceRemark"
                      :rows="6"
                      :disabled="isView || !billingNoteContainInvoiceChannel"
                    />
                  </div>
                  <div style="width: 50%">
                    <span>{{ billingNoteContainInvoiceChannel ?$t('CargoMsg.Cargo_RemarkAddContent3'): $t('CargoMsg.Cargo_RemarkAddContent') }}</span>
                    <el-input
                      v-model="billing.remarkAddContent"
                      type="textarea"
                      no="remarkAddContent"
                      :rows="6"
                      :disabled="isView || billingNoteContainInvoiceChannel"
                    />
                  </div>
                </div>
              </el-col>

            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getTitleBankList } from '@/api/partner/titleBank'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getBankAccountList } from '@/api/bankAccount'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { getCustomer } from '@/api/partner/customer'
import { getContactList } from '@/api/partner/contact'
import StrUtils from '@/utils/StrUtils'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { SETTLEMENT_TYPE_STATES, BILLING_TYPE_INTERNAL, BILLING_TYPE_OVERSEA } from '@/class/cargo/model/parameters/BillingConstants'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'

export default {
  name: 'BillForm',
  components: {

    CargoAdvanceSelect, NumInput
  },
  props: {
    billing: { type: Object },
    billingFormParams: { type: Object },
    isView: { type: Boolean },
    requestSource: { type: String, default: '' },
    createBillWay: { type: Number, default: 0 }, // 创建账单方式【0：结算对象 1、结算代理】
    accounts: { type: Array, required: false, default: () => [] } // 费用列表数据
  },
  data() {
    return {
      value: '',
      selectTypeNames: TYPE_NAMES,
      SETTLEMENT_TYPE_STATES,
      changeStatus: false,
      invoiceGoodsName: {
        gridApi: null,
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowHeight: 30,
          rowSelection: 'single',
          singleClickEdit: true,
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          defaultColDef: {
            filter: false
          }
        }
      },
      titleArray: [], // 开票抬头集合
      titleBankArray: [], // 开票抬头对应的开票银行,既开户银行集合
      settlementAgentArray: [], // 结算代理集合
      ourBankAccountArray: [], // 我司银行集
      sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
      sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
      sourceRate3Enable: true, // 第三行汇率是否可编辑，默认不可编辑
      isZh: this.$store.getters.language === 'zh',
      accountContactsArray: [], // 结算单位联系人
      arSettlementUnitOptional: false,
      // invoiceTypes: InvoiceConstant.BILLING_INVOICE_TYPES,
      titleBankUuid: '', // 开户银行UUID
      invoiceTitleUuid: '', // 开票抬头UUID
      accountArray: [], // 结算对象集合
      BILLING_TYPE_INTERNAL,
      BILLING_TYPE_OVERSEA
    }
  },
  computed: {
    invoiceMakeTypes() {
      // CARGO-19406 国内账单创建账单时，当 发票类型 = 内部发票 时，发票种类可选项只有纸质发票
      if (this.billing.billingType === BILLING_TYPE_INTERNAL.code && !this.billing.uuid && this.billing.invoiceType === InvoiceConstant.BILLING_INVOICE_TYPE_INTERNAL.code) {
        // 当只有纸质发票时，将invoiceMakeTypes改成空
        if (this.billing.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_ELECTRONIC_INVOICE.code) {
          this.billing.invoiceMakeType = ''
        }
        return [InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE]
      } else {
        return InvoiceConstant.BILLING_INVOICE_CATEGORY
      }
    },
    invoiceTypes() {
      // CARGO-38028 发票种类为纸质发票时，发票类型不可选电子发票相关类型
      const ifPaperInvoiceOrNoMakeType = this.billing.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code || !this.billing.invoiceMakeType
      const ifSpecialInterface = this.billingFormParams.eiTaxControlInterfaceName === 'BWJSY' || this.billingFormParams.eiTaxControlInterfaceName === 'TAX_EASY_THREE_PLUS' || this.billingFormParams.eiTaxControlInterfaceName === 'NUONUO' || this.billingFormParams.toExoSystemYGSH
      if (this.billingFormParams.newInvoiceTypesOfBilling && ifSpecialInterface) {
        return ifPaperInvoiceOrNoMakeType ? InvoiceConstant.BILLING_INVOICE_TYPES_CJ : InvoiceConstant.BILLING_INVOICE_TYPES_CJ_EI
      }
      if (this.billingFormParams.newInvoiceTypesOfBilling) {
        return InvoiceConstant.BILLING_INVOICE_TYPES_CJ
      }
      if (ifSpecialInterface) {
        return ifPaperInvoiceOrNoMakeType ? InvoiceConstant.BILLING_INVOICE_TYPES : InvoiceConstant.BILLING_INVOICE_TYPES_EI
      }
      return InvoiceConstant.BILLING_INVOICE_TYPES
    },
    isBySettlementAgent() { // 按结算代理新增
      return this.createBillWay === 1 && !this.billing.uuid
    },
    sourceRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency1)
    },
    sourceRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency2)
    },
    sourceRate3Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency3)
    },
    // 是否开启了账单预开票
    billingNoteContainInvoice() {
      return this.billingFormParams.billingNoteContainInvoiceReques && this.billing.makeInvoiceType === 0 &&
        (this.billing.billingType === BILLING_TYPE_INTERNAL.code || this.billing.billingType === BILLING_TYPE_OVERSEA.code)
    },
    billingNoteContainInvoiceChannel() {
      return this.billingFormParams.billingNoteContainInvoiceReques === 2
    },
    invoiceGoodsNameColumnDefs() {
      return [
        { headerName: 'CNY' + this.$t('CargoMsg.Cargo_Project'), field: 'goodsNameRmb', width: 120,
          editable: (params) => !this.isView && params.data.hasRmb,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            return {
              selectProps: {
                staticOptions: (this.billingFormParams.goodsNames || []),
                clearable: false,
                filterable: true,
                tagName: 'goodsNameRMB',
                tagValue: 'goodsNameRMB'
              }
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        },
        { headerName: 'USD' + this.$t('CargoMsg.Cargo_Project'), field: 'goodsNameUsd', width: 120,
          editable: (params) => !this.isView && params.data.hasUsd,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            return {
              selectProps: {
                staticOptions: (this.billingFormParams.goodsNames || []),
                clearable: false,
                filterable: true,
                tagName: 'goodsNameUSD',
                tagValue: 'goodsNameUSD'
              }
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        },
        { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'el-select',
            options: InvoiceConstant.INVOICE_GOODS_NAME_TAX_RATE2,
            optionField: {
              labelFunc: item => {
                return item.chineseName
              },
              value: 'code'
            }
          }
        }
      ]
    }
  },
  watch: {
    'billing.accountId': {
      handler: function(val, oldVal) {
        if (val > 0) {
          if (this.isBySettlementAgent) { // 结算代理
            this.accountArray = this.getChargeAccounts()
            this.querySettlementAgent(this.billing.settlementAgentId)
          } else {
            const company = this.querySettlement(val)
            // 查询结算代理
            if (!this.billing.settlementAgentId) {
              this.billing.settlementAgentId = 0
            }
            this.querySettlementAgentList(val, company, this.billing.settlementAgentId !== 0)
          }
          // 获取结算对象的开票抬头(如果旧值为0，说明是第一次初始化，将直接用传递进来的发票抬头)
          if (this.billing.title) {
            this.billing.title = this.billing.title.trim()
          }
          this.queryTitleList(val, !StrUtils.isEmpty(this.billing.title) && !oldVal) // 一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行
          // 获取结算对象联系人
          this.queryAccountContact(this.billing.accountId)
        }
      },
      deep: true
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.billingFormParams.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
    this.billingFormParams.billingNoteContainInvoiceReques = Number(cache.config.get('BillingNoteContainInvoiceReques'))
    this.billingFormParams.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
    this.arSettlementUnitOptional = Number(cache.config.get('ArSettlementUnitOptional')) === 1
    this.queryOurBankAccountList()
    if (this.requestSource === 'booking' && this.billing.accountId > 0) {
      if (this.isBySettlementAgent) { // 结算代理
        this.accountArray = this.getChargeAccounts()
        this.querySettlementAgent(this.billing.settlementAgentId)
      } else { // 结算对象
        const company = this.querySettlement(this.billing.accountId)
        // 查询结算代理
        if (!this.billing.settlementAgentId) {
          this.billing.settlementAgentId = 0
        }
        this.querySettlementAgentList(this.billing.accountId, company, this.billing.settlementAgentId !== 0)
      }
      // 获取结算对象的开票抬头
      this.queryTitleList(this.billing.accountId, !StrUtils.isEmpty(this.billing.title)) // 一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行
      // 获取结算对象联系人
      this.queryAccountContact(this.billing.accountId)
    }
  },
  methods: {
    // 获取结算代理
    async querySettlementAgentList(accountId, account = null, hasSettlement = false) {
      let settlementAgentId = 0
      let settlementAgentArray = await getSettlementAgentsByCmpIdx(accountId).then((res) => { return res.data })
      if (settlementAgentArray && settlementAgentArray.length > 0) {
        if (!hasSettlement) {
          const settlementAgent = settlementAgentArray[0]
          settlementAgentId = settlementAgent['cmpIdx']
        } else {
          settlementAgentId = isNaN(this.billing.settlementAgentId) ? 0 : this.billing.settlementAgentId
        }
      } else {
        settlementAgentArray = []
        if (!hasSettlement) {
          settlementAgentArray = []
          settlementAgentId = accountId
        } else {
          settlementAgentId = this.billing.settlementAgentId
        }
      }
      if (settlementAgentArray.indexOf(account) < 0) {
        settlementAgentArray.push(account)
      }
      this.settlementAgentArray = settlementAgentArray
      if (!this.billing.uuid && !this.isView && (this.billing.settlementAgentId === 0 || !this.billing.settlementAgentId)) {
        this.billing.settlementAgentId = settlementAgentId
      }
    },
    // 根据结算对象ID获取结算对象中文名或者英文名
    querySettlement(accountId = 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(accountId))
      if (company) {
        this.billing.settlement = CustomLableUtils.getLabel(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(accountId), 'auto_accountId')
      }
      return company
    },
    // 根据结算代理ID获取中文名或者英文名
    querySettlementAgent(settlementAgentId = 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(settlementAgentId))
      if (company) {
        this.billing.settlementAgent = CustomLableUtils.getLabel(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(settlementAgentId), 'auto_accountId')
      }
      return company
    },
    // 查询开票抬头
    queryTitleList(accountId, hasTitle) {
      queryTitleByCpmIdx(accountId).then((res) => {
        let titleArray = []
        if (res.data && res.data.length > 0) {
          titleArray = res.data
        }
        const { title, buyerTaxAccount } = this.billing
        if (title) {
          if (!titleArray.find(item => item.title === title)) {
            titleArray.push({ title: title, uuid: title })
            this.invoiceTitleUuid = title
          } else {
            const titles = titleArray.filter(t => t.title === title)
            if (titles.length === 1) {
              this.invoiceTitleUuid = titles[0].uuid
              this.billing.customerEmail = titles[0].email || ''
              if (!this.billing.uuid) {
                this.billing.invoiceMakeType = titles[0].invoiceMakeType
                this.billing.invoiceType = titles[0].invoiceType
                if (titles[0].invoiceDemand) {
                  this.billing.invoiceDemand = titles[0].invoiceDemand
                }
              }
            }
            if (titles.length > 1) {
              const title = titles.find(item => item.taxAccount === buyerTaxAccount)
              if (title) {
                this.invoiceTitleUuid = title.uuid
                this.billing.customerEmail = title.email || ''
                if (!this.billing.uuid) {
                  this.billing.invoiceMakeType = title.invoiceMakeType
                  this.billing.invoiceType = title.invoiceType
                  if (title.invoiceDemand) {
                    this.billing.invoiceDemand = title.invoiceDemand
                  }
                }
              } else {
                this.invoiceTitleUuid = titles[0].uuid
                this.billing.customerEmail = titles[0].email || ''
                if (!this.billing.uuid) {
                  this.billing.invoiceMakeType = titles[0].invoiceMakeType
                  this.billing.invoiceType = titles[0].invoiceType
                  if (titles[0].invoiceDemand) {
                    this.billing.invoiceDemand = titles[0].invoiceDemand
                  }
                }
              }
            }
          }
        }
        this.titleArray = titleArray
        this.titleOptionsChargeEvent(titleArray, hasTitle)
      })
    },
    // 开票抬头数据源变更回调函数 [hasTitle - 是否使用费用的开票抬头]
    titleOptionsChargeEvent(options, hasTitle) {
      const billing = this.billing
      if (!billing.uuid) {
        // 账单新增
        if (billing.accountId > 0) {
          // 根据结算对象ID获取结算对象
          const company = getObjectByCache(
            basicCacheKeys.basic_data_Company,
            'cmpIdx',
            Number(billing.accountId)
          )
          if (!hasTitle) {
            if (!options || options.length === 0) {
              billing.title = company ? company['chineseName'] : null
              if (!this.titleArray.find(item => item.title === billing.title)) {
                this.titleArray.push({ title: billing.title, uuid: billing.title })
                this.invoiceTitleUuid = billing.title
              }
            } else {
              for (let i = 0; i < options.length; i++) {
                const item = options[i]
                if (item['defaultTitle'] === true) {
                  billing.title = item['title']
                  billing.invoiceMakeType = item['invoiceMakeType']
                  billing.invoiceType = item['invoiceType']
                  billing.customerEmail = item['email'] || ''
                  this.invoiceTitleUuid = item.uuid
                  break
                }
              }
            }
          } else {
            const titles = options.filter(title => title.title === billing.title)
            if (titles.length === 1) {
              this.invoiceTitleUuid = titles[0].uuid
              billing.invoiceMakeType = titles[0].invoiceMakeType
              billing.invoiceType = titles[0].invoiceType
              if (titles[0].invoiceDemand) {
                billing.invoiceDemand = titles[0].invoiceDemand
              }
              billing.customerEmail = titles[0].email || ''
            }
            if (titles.length > 1) {
              const title = titles.find(item => item.taxAccount === billing.buyerTaxAccount)
              if (title) {
                this.invoiceTitleUuid = title.uuid
                billing.invoiceMakeType = title.invoiceMakeType
                billing.invoiceType = title.invoiceType
                if (title.invoiceDemand) {
                  billing.invoiceDemand = title.invoiceDemand
                }
                billing.customerEmail = title.email || ''
              } else {
                this.invoiceTitleUuid = titles[0].uuid
                billing.invoiceMakeType = titles[0].invoiceMakeType
                billing.invoiceType = titles[0].invoiceType
                if (titles[0].invoiceDemand) {
                  billing.invoiceDemand = titles[0].invoiceDemand
                }
                billing.customerEmail = titles[0].email || ''
              }
            }
          }
          if (company) {
            getCustomer({ companyUuid: company['uuid'] }).then((res) => {
              const customer = res.data
              if (!billing.invoiceDemand) {
                billing.invoiceDemand = customer ? customer['invoiceRemarks'] : ''
              }
              billing.makeInvoiceType = customer.invoiceMode
            })
          }
        }
      }
      if (billing.title) {
        let title = null
        for (let i = 0; i < options.length; i++) {
          const item = options[i]
          if (item['uuid'] === this.invoiceTitleUuid) {
            title = item
            billing.customerEmail = title['email'] || ''
            break
          }
        }
        if (title && !this.billing.uuid) {
          billing.invoiceMakeType = title['invoiceMakeType']
          billing.invoiceType = title['invoiceType']
          if (!billing.invoiceDemand && title['invoiceDemand']) {
            billing.invoiceDemand = title['invoiceDemand']
          }
        }
        this.getTitleBankByTitle(title)
      } else {
        this.getTitleBankByTitle()
      }
    },
    // 查询当前分公司下的我司银行账号
    queryOurBankAccountList() {
      getBankAccountList(this.$store.getters.currentOfficeUuid).then((res) => {
        if (res.data && res.data.length > 0) {
          const ourBankAccountArray = res.data
          if (!this.billing.uuid) {
            // 新建账单时默认带出账单币种对应的默认银行,如果没有则随机去一条和账单币种相同的银行
            let isFind = false
            let bank = null
            for (let i = 0; i < ourBankAccountArray.length; i++) {
              const bankAccount = ourBankAccountArray[i]
              if (bankAccount['currency'] === this.billing.currency) {
                bank = bankAccount
                if (bankAccount['defaultPayment']) {
                  this.billing.bankAccountId = bankAccount['accountId']
                  this.billing.bankAccount = bankAccount['accountNo']
                  isFind = true
                  break
                }
              }
            }
            if (!isFind && bank) {
              this.billing.bankAccountId = bank['accountId']
              this.billing.bankAccount = bank['accountNo']
            }
          } else {
            for (let i = 0; i < ourBankAccountArray.length; i++) {
              const bankAccount = ourBankAccountArray[i]
              if (bankAccount['accountId'] === this.billing.bankAccountId) {
                this.billing.bankAccount = bankAccount['accountNo']
                break
              }
            }
          }
          this.ourBankAccountArray = ourBankAccountArray
        }
      })
    },
    // 开票抬头变更回调函数
    titleChangeEvent(titleItem) {
      const billing = this.billing
      this.invoiceTitleUuid = titleItem['uuid']
      billing.title = titleItem['title']
      billing.invoiceType = titleItem['invoiceType']
      billing.invoiceMakeType = titleItem['invoiceMakeType']
      if (titleItem['invoiceDemand']) {
        billing.invoiceDemand = titleItem['invoiceDemand']
      }
      billing.customerEmail = titleItem['email'] || ''
      this.changeStatus = true
      this.getTitleBankByTitle(titleItem)
    },
    // 获取开票抬头所维护的开票银行
    async getTitleBankByTitle(title = null) {
      const billing = this.billing
      let changeStatus = this.changeStatus
      if (title) {
        billing.customerEmail = title['email'] || ''
        if (title['uuid'] && title['uuid'] !== title['title']) {
          const titleUuidList = title['uuid']
          await getTitleBankList({ titleUuidList: [titleUuidList] }).then((res) => {
            const titleBanks = res.data
            if (titleBanks && titleBanks.length > 0 || (billing.buyerBank !== null && billing.buyerBank !== '')) {
              if (!titleBanks.find(item => item.bank === billing.buyerBank && item.bankAccount === billing.buyerBankAccount)) {
                // 账单原有开户银行在抬头维护的银行里找不到时，临时补一条供下拉显示。
                // uuid 不能用 billing.uuid（账单自身uuid）：编辑分支(下文 966)会按 bank+bankAccount 反查 uuid，
                // 命中这条后会把 titleBankUuid 定位成账单uuid，开户银行栏(:default-value="titleBankUuid"、:cache="false")
                // 用账单uuid去查银行查不到，就回显成一串uuid。这里用空uuid，回显为空，用户可在下拉里重选。
                titleBanks.push({ bank: billing.buyerBank, uuid: '', bankAccount: billing.buyerBankAccount })
              }
              this.titleBankArray = titleBanks
              if (!billing.uuid || changeStatus) {
                for (let i = 0; i < titleBanks.length; i++) {
                  const bank = titleBanks[i]
                  if (bank['defaultBank'] === true) {
                    this.titleBankUuid = bank['uuid']
                    billing.buyerBank = bank['bank']
                    billing.buyerBankAccount = bank['bankAccount']
                    break
                  }
                }
              } else { // 编辑状态下，根据开户银行名称和账号定位UUID
                for (const bank of titleBanks) {
                  if (bank.bank === billing.buyerBank && billing.buyerBankAccount === bank.bankAccount) {
                    this.titleBankUuid = bank['uuid']
                    break
                  }
                }
              }
            } else {
              this.titleBankArray = []
              this.titleBankUuid = ''
              billing.buyerBank = ''
              billing.buyerBankAccount = ''
            }
          })
        } else {
          this.titleBankUuid = ''
          billing.buyerBank = ''
          billing.buyerBankAccount = ''
        }
        if (!billing.uuid || changeStatus) {
          // 账单新增
          changeStatus = false
          billing.buyerTaxAccount = title['taxAccount']
          billing.buyerAddress = title['address']
          billing.buyerTelephone = title['telephone']
          if (!billing.invoiceDemand && title['invoiceDemand']) {
            billing.invoiceDemand = title['invoiceDemand']
          }
        }
      } else {
        if (!billing.uuid) {
          billing.buyerTaxAccount = ''
          billing.buyerAddress = ''
          billing.buyerTelephone = ''
        }
        this.titleBankArray = []
        this.titleBankUuid = ''
        billing.buyerBank = ''
        billing.buyerBankAccount = ''
      }
      this.changeStatus = changeStatus
      this.setDefaultInvoiceContent()
    },
    // 开户银行回调事件
    getBankCusFromChild(obj) {
      this.titleBankUuid = obj.uuid
      this.billing.buyerBank = obj.bank
      this.billing.buyerBankAccount = obj.bankAccount
    },
    // 我司银行账号下拉选择时,带出默认维护的银行账号
    getOurBankAccountFromChild(obj) {
      this.billing.bankAccountId = obj.accountId
      this.billing.bankAccount = obj.accountNo
    },
    // 账单币种修改事件
    currencyChangeEvent(obj) {
      if (obj.value) {
        this.billing.currency = obj.value
        this.changeOurBankByCurrency()
      }
      this.$emit('currencyChangeEvent', obj)
    },
    // 修改我司银行
    changeOurBankByCurrency() {
      const ourBankAccountArray = this.ourBankAccountArray
      let isFind = false
      let bank = null
      for (let i = 0; i < ourBankAccountArray.length; i++) {
        const bankAccount = ourBankAccountArray[i]
        if (bankAccount['currency'] === this.billing.currency) {
          bank = bankAccount
          if (bankAccount['defaultPayment']) {
            this.billing.bankAccountId = bankAccount['accountId']
            this.billing.bankAccount = bankAccount['accountNo']
            isFind = true
            break
          }
        }
      }
      if (!isFind) {
        if (bank) {
          this.billing.bankAccountId = bank['accountId']
          this.billing.bankAccount = bank['accountNo']
        } else {
          this.billing.bankAccountId = 0
          this.billing.bankAccount = ''
        }
      }
    },
    calculateAmount() {
      this.$emit('calculateAmount')
    },
    // 账单日期修改事件
    inputDateChange() {
      this.$emit('currencyChangeEvent', { value: this.billing.currency })
    },
    // 查询结算对象联系人
    queryAccountContact(accountId) {
      if (accountId > 0) {
        getContactList({ cmpIdx: accountId }).then((res) => {
          let contacts = []
          if (res.data && res.data.list.length > 0) {
            contacts = res.data.list
          }
          this.accountContactsArray = contacts
          if (contacts.length > 0) {
            if (!this.billing.uuid) { // 新增的时候，默认带出联系人信息
              for (const contact of contacts) {
                if (contact.defaultContact) {
                  this.billing.accountContacts = contact.contactPerson
                  this.billing.accountContactsTel = contact.telephone
                  break
                }
              }
            }
          }
        })
      }
    },
    // 结算单位联系人
    accountContactChangeEvent(contact) {
      if (contact) {
        this.billing.accountContacts = contact.contactPerson
        if (contact.hasOwnProperty('telephone')) {
          this.billing.accountContactsTel = contact.telephone
        }
      }
    },
    changeInvoiceMakeType() {
      const elInvoiceTypes = [InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT_DEDICATED.code, InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT.code]
      if (this.billing.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code && elInvoiceTypes.includes(this.billing.invoiceType)) {
        this.billing.invoiceType = ''
      }
    },
    /**
     * 获取账单关联的费用结算对象
     */
    getChargeAccounts() {
      if (!this.isBySettlementAgent || !this.accounts || this.accounts.length <= 0) return []
      const accountMap = {}
      const accounts = []
      for (const accountId of this.accounts) {
        if (!accountId || accountMap[accountId]) {
          continue
        }
        accountMap[accountId] = true
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', accountId)
        if (company) {
          accounts.push(company)
        }
      }
      return accounts
    },
    makeInvoiceTypeChange(e) {
      if (this.billing.makeInvoiceType === 0) {
        this.$emit('refreshOtherBillingData')
      }
    },
    detailMakeInvoiceChange(e) {
      if (!this.billing.detailMakeInvoice) {
        this.$emit('refreshOtherBillingData')
      }
    },
    onCellChange(params) {
      const data = params.data
      const filed = params.colDef.field
      switch (filed) {
        case 'goodsNameRmb':
          data.goodsNameRmb = params.newValue
          break
        case 'goodsNameUsd':
          data.goodsNameUsd = params.newValue
          break
      }
    },
    // 默认开票信息
    setDefaultInvoiceContent() {
      if (!this.billing.uuid && (StrUtils.isEmpty(this.billing.invoiceMakeType) || StrUtils.isEmpty(this.billing.invoiceType)) &&
        LocalStorageUtilsNew.hasConfiguration('invoceByNewBilling')) {
        const item = LocalStorageUtilsNew.getConfiguration('invoceByNewBilling')
        console.log('invoceByNewBilling', item)
        if (item) {
          if (StrUtils.isEmpty(this.billing.invoiceMakeType)) this.billing.invoiceMakeType = item.invoiceMakeType || ''
          if (StrUtils.isEmpty(this.billing.invoiceType)) this.billing.invoiceType = item.invoiceType || ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-form-content{
  .el-col{
    margin-top: 0 !important;
    &.inline{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .el-form-item{
        flex: 1;
        &:last-of-type{
          /deep/ .el-form-item__label{
            text-indent: 10px;
          }
        }
      }
    }
  }
}
</style>
